// Game data is JSON (CLAUDE.md conventions), validated once at import so bad data fails fast, and
// cross-checked so every id a mech or ability refers to exists.
import { AudioBankSchema } from './audio-schema.js';
import audioCuesJson from './audio-cues.json' with { type: 'json' };
import { AbilityDefinitionSchema, } from './ability-schema.js';
import bastionAbilities from './abilities/bastion.json' with { type: 'json' };
import colossusAbilities from './abilities/colossus.json' with { type: 'json' };
import corsairAbilities from './abilities/corsair.json' with { type: 'json' };
import golemAbilities from './abilities/golem.json' with { type: 'json' };
import halberdAbilities from './abilities/halberd.json' with { type: 'json' };
import juggernautAbilities from './abilities/juggernaut.json' with { type: 'json' };
import kestrelAbilities from './abilities/kestrel.json' with { type: 'json' };
import leviathanAbilities from './abilities/leviathan.json' with { type: 'json' };
import lynxAbilities from './abilities/lynx.json' with { type: 'json' };
import oracleAbilities from './abilities/oracle.json' with { type: 'json' };
import roninAbilities from './abilities/ronin.json' with { type: 'json' };
import sparrowAbilities from './abilities/sparrow.json' with { type: 'json' };
import tempestAbilities from './abilities/tempest.json' with { type: 'json' };
import vesperAbilities from './abilities/vesper.json' with { type: 'json' };
import wardenAbilities from './abilities/warden.json' with { type: 'json' };
import { BalanceSchema } from './balance-schema.js';
import { BalanceOverridesSchema, deepMerge, } from './overrides-schema.js';
import balanceJson from './balance.json' with { type: 'json' };
import { CosmeticDefinitionSchema } from './cosmetic-schema.js';
import decalsJson from './cosmetics/decals.json' with { type: 'json' };
import emissivesJson from './cosmetics/emissives.json' with { type: 'json' };
import paintsJson from './cosmetics/paints.json' with { type: 'json' };
import partsJson from './cosmetics/parts.json' with { type: 'json' };
import { MechDefinitionSchema } from './mech-schema.js';
import bastionJson from './mechs/bastion.json' with { type: 'json' };
import colossusJson from './mechs/colossus.json' with { type: 'json' };
import corsairJson from './mechs/corsair.json' with { type: 'json' };
import golemJson from './mechs/golem.json' with { type: 'json' };
import halberdJson from './mechs/halberd.json' with { type: 'json' };
import juggernautJson from './mechs/juggernaut.json' with { type: 'json' };
import kestrelJson from './mechs/kestrel.json' with { type: 'json' };
import leviathanJson from './mechs/leviathan.json' with { type: 'json' };
import lynxJson from './mechs/lynx.json' with { type: 'json' };
import oracleJson from './mechs/oracle.json' with { type: 'json' };
import roninJson from './mechs/ronin.json' with { type: 'json' };
import sparrowJson from './mechs/sparrow.json' with { type: 'json' };
import tempestJson from './mechs/tempest.json' with { type: 'json' };
import vesperJson from './mechs/vesper.json' with { type: 'json' };
import wardenJson from './mechs/warden.json' with { type: 'json' };
import { ModuleDefinitionSchema } from './module-schema.js';
import capacitorModule from './modules/capacitor.json' with { type: 'json' };
import gyroModule from './modules/gyro.json' with { type: 'json' };
import heatSinkModule from './modules/heat-sink.json' with { type: 'json' };
import hullPlatingModule from './modules/hull-plating.json' with { type: 'json' };
import jetsModule from './modules/jets.json' with { type: 'json' };
import loaderModule from './modules/loader.json' with { type: 'json' };
import platingModule from './modules/plating.json' with { type: 'json' };
import servoModule from './modules/servo.json' with { type: 'json' };
import shieldCellsModule from './modules/shield-cells.json' with { type: 'json' };
import stabiliserModule from './modules/stabiliser.json' with { type: 'json' };
import { WeaponDefinitionSchema } from './weapon-schema.js';
import arcCannon from './weapons/arc-cannon.json' with { type: 'json' };
import arcPistol from './weapons/arc-pistol.json' with { type: 'json' };
import assaultRifle from './weapons/assault-rifle.json' with { type: 'json' };
import autoShotgunDual from './weapons/auto-shotgun-dual.json' with { type: 'json' };
import autocannonTwin from './weapons/autocannon-twin.json' with { type: 'json' };
import beamRifle from './weapons/beam-rifle.json' with { type: 'json' };
import flamethrower from './weapons/flamethrower.json' with { type: 'json' };
import gatling from './weapons/gatling.json' with { type: 'json' };
import howitzer from './weapons/howitzer.json' with { type: 'json' };
import hydraulicFists from './weapons/hydraulic-fists.json' with { type: 'json' };
import laserLance from './weapons/laser-lance.json' with { type: 'json' };
import meleeBash from './weapons/melee-bash.json' with { type: 'json' };
import microMissilePod from './weapons/micro-missile-pod.json' with { type: 'json' };
import monoKatana from './weapons/mono-katana.json' with { type: 'json' };
import mortarShell from './weapons/mortar-shell.json' with { type: 'json' };
import piercingBeam from './weapons/piercing-beam.json' with { type: 'json' };
import plasmaBlades from './weapons/plasma-blades.json' with { type: 'json' };
import railPistol from './weapons/rail-pistol.json' with { type: 'json' };
import siphonBeam from './weapons/siphon-beam.json' with { type: 'json' };
import smgTwin from './weapons/smg-twin.json' with { type: 'json' };
import swarmMissile from './weapons/swarm-missile.json' with { type: 'json' };
import turretGun from './weapons/turret-gun.json' with { type: 'json' };
export * from './ability-schema.js';
export * from './balance-schema.js';
export * from './overrides-schema.js';
export * from './mech-schema.js';
export * from './mech-sidecar.js';
export * from './decal-atlas.js';
export * from './cosmetic-schema.js';
export * from './module-schema.js';
export * from './weapon-schema.js';
export * from './audio-schema.js';
export * from './credits-schema.js';
function byId(items, what) {
    const out = {};
    for (const item of items) {
        if (out[item.id])
            throw new Error(`duplicate ${what} id "${item.id}"`);
        out[item.id] = item;
    }
    return Object.freeze(out);
}
export const BALANCE = BalanceSchema.parse(balanceJson);
export const WEAPONS = byId([
    arcCannon,
    arcPistol,
    assaultRifle,
    autoShotgunDual,
    autocannonTwin,
    beamRifle,
    flamethrower,
    gatling,
    howitzer,
    hydraulicFists,
    laserLance,
    meleeBash,
    microMissilePod,
    monoKatana,
    mortarShell,
    piercingBeam,
    plasmaBlades,
    railPistol,
    siphonBeam,
    smgTwin,
    swarmMissile,
    turretGun,
].map((json) => WeaponDefinitionSchema.parse(json)), 'weapon');
export const ABILITIES = byId([
    bastionAbilities,
    colossusAbilities,
    corsairAbilities,
    golemAbilities,
    halberdAbilities,
    juggernautAbilities,
    kestrelAbilities,
    leviathanAbilities,
    lynxAbilities,
    oracleAbilities,
    roninAbilities,
    sparrowAbilities,
    tempestAbilities,
    vesperAbilities,
    wardenAbilities,
]
    .flat()
    .map((json) => AbilityDefinitionSchema.parse(json)), 'ability');
/** Roster in BUILD_PLAN section 6 order. */
export const MECH_LIST = Object.freeze([
    vesperJson,
    kestrelJson,
    lynxJson,
    sparrowJson,
    wardenJson,
    halberdJson,
    corsairJson,
    oracleJson,
    roninJson,
    tempestJson,
    bastionJson,
    juggernautJson,
    colossusJson,
    golemJson,
    leviathanJson,
].map((json) => MechDefinitionSchema.parse(json)));
export const MECHS = byId([...MECH_LIST], 'mech');
export function getMech(id) {
    const def = MECHS[id];
    if (!def)
        throw new Error(`unknown mech "${id}"`);
    return def;
}
export function getWeapon(id) {
    const def = WEAPONS[id];
    if (!def)
        throw new Error(`unknown weapon "${id}"`);
    return def;
}
/** The audio cue bank (Phase 8), cross-checked so every weapon it names exists. */
export const AUDIO_BANK = AudioBankSchema.parse(audioCuesJson);
for (const weaponId of Object.keys(AUDIO_BANK.weapons)) {
    if (!WEAPONS[weaponId])
        throw new Error(`audio bank names unknown weapon "${weaponId}"`);
}
const AUDIO_CUES = byId([...AUDIO_BANK.cues], 'audio cue');
export function getAudioCue(id) {
    const cue = AUDIO_CUES[id];
    if (!cue)
        throw new Error(`unknown audio cue "${id}"`);
    return cue;
}
/** The cue a weapon's shots play: its own entry, else the one for its kind. */
export function shotCueFor(weaponId) {
    const override = AUDIO_BANK.weapons[weaponId]?.shot;
    return getAudioCue(override ?? AUDIO_BANK.kinds[getWeapon(weaponId).kind]);
}
export function getAbility(id) {
    const def = ABILITIES[id];
    if (!def)
        throw new Error(`unknown ability "${id}"`);
    return def;
}
/** The melee weapon a mech swings on F (DECISIONS.md #15). */
export function meleeWeaponOf(def) {
    return getWeapon(def.melee ?? BALANCE.melee.defaultWeapon);
}
/** The module catalog in hangar order (Phase 6). */
export const MODULE_LIST = Object.freeze([
    platingModule,
    heatSinkModule,
    loaderModule,
    servoModule,
    gyroModule,
    jetsModule,
    capacitorModule,
    stabiliserModule,
    hullPlatingModule,
    shieldCellsModule,
].map((json) => ModuleDefinitionSchema.parse(json)));
export const MODULES = byId([...MODULE_LIST], 'module');
/** The cosmetic catalog: paints, emissive colours, decals, then parts (Phase 6). */
export const COSMETIC_LIST = Object.freeze([...paintsJson, ...emissivesJson, ...decalsJson, ...partsJson].map((json) => CosmeticDefinitionSchema.parse(json)));
export const COSMETICS = byId([...COSMETIC_LIST], 'cosmetic');
export function getModule(id) {
    const def = MODULES[id];
    if (!def)
        throw new Error(`unknown module "${id}"`);
    return def;
}
export function getCosmetic(id) {
    const def = COSMETICS[id];
    if (!def)
        throw new Error(`unknown cosmetic "${id}"`);
    return def;
}
/**
 * Folds a module set into one stat-mod record: scales multiply, the armour bonus adds. Unknown
 * ids are skipped (the callers validate first); the result carries no flags, by schema.
 */
export function moduleMods(ids) {
    const out = {};
    for (const id of ids) {
        const module = MODULES[id];
        if (!module)
            continue;
        for (const [key, value] of Object.entries(module.mods)) {
            if (key === 'hpScale' || key === 'shieldScale')
                continue;
            if (key === 'armorBonus')
                out.armorBonus = (out.armorBonus ?? 0) + value;
            else
                out[key] = (out[key] ?? 1) * value;
        }
    }
    return out;
}
/** The hull and shield multipliers a module set gives a seat's definition (Phase 8). */
export function moduleCapacityScales(ids) {
    let hp = 1;
    let shield = 1;
    for (const id of ids) {
        const module = MODULES[id];
        if (!module)
            continue;
        hp *= module.mods.hpScale ?? 1;
        shield *= module.mods.shieldScale ?? 1;
    }
    return { hp, shield };
}
/** Cross-reference checks; throws with a readable message on the first problem. */
export function verifyDataIntegrity() {
    getWeapon(BALANCE.melee.defaultWeapon);
    for (const ability of Object.values(ABILITIES)) {
        for (const step of ability.steps) {
            const p = step.primitive;
            if (p.type === 'burst' || p.type === 'beam')
                getWeapon(p.weapon);
            if (p.type === 'burst' && getWeapon(p.weapon).kind !== 'projectile') {
                throw new Error(`ability "${ability.id}": burst weapon must be a projectile`);
            }
            if (p.type === 'beam' && getWeapon(p.weapon).kind !== 'beam') {
                throw new Error(`ability "${ability.id}": beam weapon must be a beam`);
            }
            if (p.type === 'deploy' && p.kind === 'turret') {
                if (!p.weapon)
                    throw new Error(`ability "${ability.id}": turrets need a weapon`);
                getWeapon(p.weapon);
            }
            if (p.type === 'deploy' && p.kind === 'barrier' && !p.halfExtents) {
                throw new Error(`ability "${ability.id}": barriers need halfExtents`);
            }
            if (p.type === 'custom') {
                throw new Error(`ability "${ability.id}": no custom primitives are registered`);
            }
        }
    }
    let starters = 0;
    for (const mech of MECH_LIST) {
        for (const w of mech.weapons)
            getWeapon(w.id);
        const melee = meleeWeaponOf(mech);
        if (melee.kind !== 'melee')
            throw new Error(`mech "${mech.id}": melee weapon is not melee`);
        const primary = getWeapon(mech.weapons[0].id);
        if (primary.kind === 'melee' && mech.melee !== primary.id) {
            throw new Error(`mech "${mech.id}": a melee primary must also be the melee weapon`);
        }
        for (const a of mech.abilities)
            getAbility(a.id);
        getAbility(mech.ultimate);
        for (const id of [...mech.counters.hard, ...mech.counters.soft])
            getMech(id);
        if (mech.starter)
            starters++;
    }
    if (starters !== 5)
        throw new Error(`expected 5 starter mechs, found ${String(starters)}`);
    for (const module of MODULE_LIST) {
        if (MECHS[module.id])
            throw new Error(`module "${module.id}" collides with a mech id`);
    }
    // Alternate primaries (Phase 8) name shipped weapons other than the stock primary.
    for (const mech of MECH_LIST) {
        const stock = mech.weapons.find((w) => w.slot === 'primary')?.id;
        for (const alt of mech.alternates.primary) {
            getWeapon(alt);
            if (alt === stock)
                throw new Error(`${mech.id}: alternate "${alt}" is its stock primary`);
        }
    }
    let freePaints = 0;
    let freeEmissives = 0;
    for (const item of COSMETIC_LIST) {
        if (MECHS[item.id] || MODULES[item.id]) {
            throw new Error(`cosmetic "${item.id}" collides with a mech or module id`);
        }
        const free = item.price === 0 && item.levelUnlock === null;
        if (item.kind === 'paint' && free)
            freePaints++;
        if (item.kind === 'emissive' && free)
            freeEmissives++;
        if (item.kind === 'part')
            getMech(item.chassis);
    }
    if (freePaints === 0)
        throw new Error('the catalog needs at least one free paint');
    if (freeEmissives === 0)
        throw new Error('the catalog needs at least one free emissive colour');
}
verifyDataIntegrity();
// ---------------------------------------------------------------------------------------------
// Balance versions (Phase 7): the catalogs with a document of overrides applied
/** The raw JSON by id: what `applyOverrides` merges into before re-parsing (Phase 7). */
const MECH_SOURCES = Object.fromEntries([
    vesperJson,
    kestrelJson,
    lynxJson,
    sparrowJson,
    wardenJson,
    halberdJson,
    corsairJson,
    oracleJson,
    roninJson,
    tempestJson,
    bastionJson,
    juggernautJson,
    colossusJson,
    golemJson,
    leviathanJson,
].map((json) => [json.id, json]));
const WEAPON_SOURCES = Object.fromEntries([
    arcCannon,
    arcPistol,
    assaultRifle,
    autoShotgunDual,
    autocannonTwin,
    beamRifle,
    flamethrower,
    gatling,
    howitzer,
    hydraulicFists,
    laserLance,
    meleeBash,
    microMissilePod,
    monoKatana,
    mortarShell,
    piercingBeam,
    plasmaBlades,
    railPistol,
    siphonBeam,
    smgTwin,
    swarmMissile,
    turretGun,
].map((json) => [json.id, json]));
let builtIn;
/** Version 0: the JSON data as shipped. */
export function builtInCatalog() {
    builtIn ??= {
        version: 0,
        balance: BALANCE,
        mechs: MECHS,
        weapons: WEAPONS,
        modulePrices: Object.fromEntries(MODULE_LIST.map((m) => [m.id, m.price])),
        cosmeticPrices: Object.fromEntries(COSMETIC_LIST.map((c) => [c.id, c.price])),
    };
    return builtIn;
}
/** Problems a document has beyond its shape: ids that name nothing, prices that cannot apply. */
export function overrideIssues(doc) {
    const issues = [];
    for (const mechId of Object.keys(doc.mechs ?? {})) {
        const mech = MECHS[mechId];
        if (!mech)
            issues.push(`mechs.${mechId}: no such mech`);
        else if (mech.starter && doc.mechs?.[mechId]?.unlockCost !== undefined) {
            issues.push(`mechs.${mechId}.unlockCost: starters are always owned`);
        }
    }
    for (const weaponId of Object.keys(doc.weapons ?? {})) {
        if (!WEAPONS[weaponId])
            issues.push(`weapons.${weaponId}: no such weapon`);
    }
    for (const moduleId of Object.keys(doc.prices?.modules ?? {})) {
        if (!MODULES[moduleId])
            issues.push(`prices.modules.${moduleId}: no such module`);
    }
    for (const cosmeticId of Object.keys(doc.prices?.cosmetics ?? {})) {
        const item = COSMETICS[cosmeticId];
        if (!item)
            issues.push(`prices.cosmetics.${cosmeticId}: no such cosmetic`);
        else if (item.levelUnlock !== null) {
            issues.push(`prices.cosmetics.${cosmeticId}: unlocked by level, not for sale`);
        }
    }
    return issues;
}
/**
 * Merges a document into the catalogs and re-parses every touched definition with its full
 * schema, so the result is exactly as valid as the JSON. Throws on the first problem; callers
 * that want a list run `overrideIssues` and the schema first.
 */
export function applyOverrides(doc, version) {
    const parsed = BalanceOverridesSchema.parse(doc);
    const issues = overrideIssues(parsed);
    if (issues.length > 0)
        throw new Error(`balance overrides: ${issues.join('; ')}`);
    const base = builtInCatalog();
    const mechs = { ...base.mechs };
    for (const [id, patch] of Object.entries(parsed.mechs ?? {})) {
        mechs[id] = MechDefinitionSchema.parse(deepMerge(MECH_SOURCES[id], patch, `mechs.${id}`, getMech(id)));
    }
    const weapons = { ...base.weapons };
    for (const [id, patch] of Object.entries(parsed.weapons ?? {})) {
        weapons[id] = WeaponDefinitionSchema.parse(deepMerge(WEAPON_SOURCES[id], patch, `weapons.${id}`, getWeapon(id)));
    }
    return {
        version,
        balance: parsed.balance
            ? BalanceSchema.parse(deepMerge(BALANCE, parsed.balance, 'balance'))
            : BALANCE,
        mechs,
        weapons,
        modulePrices: { ...base.modulePrices, ...(parsed.prices?.modules ?? {}) },
        cosmeticPrices: { ...base.cosmeticPrices, ...(parsed.prices?.cosmetics ?? {}) },
    };
}
const catalogCache = new Map();
/**
 * The catalog for a published version, memoised by version and content (published rows never
 * change, but a test database restarts its numbering). Version 0 and drafts (pass 0) are never
 * cached.
 */
export function effectiveCatalog(doc, version) {
    if (version <= 0) {
        return Object.keys(doc).length === 0 ? builtInCatalog() : applyOverrides(doc, 0);
    }
    const key = `${String(version)}:${JSON.stringify(doc)}`;
    const hit = catalogCache.get(key);
    if (hit)
        return hit;
    const built = applyOverrides(doc, version);
    catalogCache.set(key, built);
    return built;
}
//# sourceMappingURL=index.js.map